import { changePassword } from '../api/change-password'
import { useState } from 'react'
import { getModalById, PLATE_CHANGE_PASSWORD } from '#/features/modals'
import { useShowDataStore } from '#/shared/lib/hooks/use-show-data'
import { useForm } from 'react-hook-form'
import { makePrivateRequest } from '#/shared/api'

interface ChangePasswordForm {
	password: string
	newPassword: string
}

export const useChangePassword = () => {
	const modal = getModalById(PLATE_CHANGE_PASSWORD)
	const {
		register,
		formState: { errors },
		reset,
		trigger,
		watch,
		handleSubmit,
		setError,
		setValue,
	} = useForm<ChangePasswordForm>()
	const { showMessage } = useShowDataStore()
	const [passwordShowed, setPasswordShowed] = useState(false)

	const onSubmit = handleSubmit(
		makePrivateRequest(async ({ password, newPassword }) => {
			if (password !== newPassword) {
				showMessage('Пароли не совпадают')
				setError('password', { message: 'Пароли не совпадают' })
				return setError('newPassword', { message: 'Пароли не совпадают' })
			}

			const { data, status } = await changePassword(modal.getStoreProperty<string>('email')!, password, newPassword)

			if (status !== 200) return showMessage(data.detail)

			showMessage('Пароль изменен успешно!', 'success')

			modal.setState(false)

			reset()
		})
	)

	return { onSubmit, register, watch, reset, errors, trigger, setValue, passwordShowed, setPasswordShowed }
}
